import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LANGUAGES, getLang, onLangChange, setLang, initTranslator, onRoute } from "@/lib/siteTranslator";

const short = (c) => (c === "zh-CN" ? "ZH" : c.toUpperCase());

export default function LanguageSwitcher() {
  const { pathname } = useLocation();
  const [lang, setL] = useState(getLang());
  useEffect(() => onLangChange(setL), []);
  if (pathname.startsWith("/admin")) return null;
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button type="button" translate="no" data-testid="language-switcher-btn" aria-label="Change language" title="Language"
          className="notranslate inline-flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-md border border-zinc-300 dark:border-zinc-700 bg-white/70 dark:bg-zinc-900/70 text-[11px] font-semibold tracking-wider text-zinc-700 dark:text-zinc-200 hover:bg-zinc-100 dark:hover:bg-zinc-800 hover:border-zinc-400 dark:hover:border-zinc-600 transition-colors focus:outline-none focus:ring-2 focus:ring-[#FF4500]/50">
          {short(lang)}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" translate="no" data-testid="language-switcher-menu"
        className="notranslate w-52 max-h-80 overflow-y-auto bg-white dark:bg-zinc-950 border-zinc-200 dark:border-zinc-800">
        {LANGUAGES.map(([code, name]) => (
          <DropdownMenuItem key={code} onSelect={() => setLang(code)} data-testid={`language-option-${code}`}
            className="flex items-center justify-between gap-2 text-sm cursor-pointer text-zinc-800 dark:text-zinc-200">
            <span dir="auto">{name}</span>
            <span className="flex items-center gap-1.5 text-[10px] text-zinc-500">
              {short(code)}{code === lang && <Check size={12} className="text-[#FF4500]" />}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function SiteTranslator() {
  const { pathname } = useLocation();
  useEffect(() => { initTranslator(); }, []);
  useEffect(() => { onRoute(); }, [pathname]);
  return null;
}
